import React from "react";
import NexEnginesCoreLayout from "@/layouts/NexEnginesCoreLayout";

/**
 * /os — mounted twice: at /os (operator-facing) and at /admin (admin default).
 * Same layout, same data, same experience.
 */
export default function OsPage() {
  return <NexEnginesCoreLayout />;
}
